import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { YoklamaFacade } from './core/yoklama.facade';
import { AppState, Student } from './core/app_state';
import * as L from 'leaflet';
import { ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import {
  CustomToastrService,
  ToastrMessageType,
  ToastrPosition,
} from 'app/base/services/custom-toast-service';

import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
@Component({
  selector: 'app-teacher-course',
  templateUrl: './teacher-course.component.html',
  styleUrls: ['./teacher-course.component.css'],
})
export class TeacherCourseComponent implements OnInit, AfterViewInit {
  state$!: Observable<AppState>;
  qrBase64: any;
  students: any;

  @ViewChild('mapContainer', { static: false })
  mapContainer!: ElementRef<HTMLDivElement>;

  map: any;
  marker: any;
  mapInitialized = false;
  mapMessage = '';
  constructor(
    public facade: YoklamaFacade,
    public alertservice: CustomToastrService,
  ) {
    // back/forward tuşlarını engelle
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', (event) => {
      window.history.pushState(null, '', window.location.href);
      if (this.facade.state.getState().course.started) {
        alert('Ders devam ederken sayfayı değiştiremezsiniz!');
      }
    });
  }
  ngAfterViewChecked(): void {
    const s = this.facade.state.getState();

    if (s.ui.konumKontrol && s.ui.currentStep === 2) {
      this.konumislmeleri(2);
    }
  }

  ngAfterViewInit(): void {
    const s = this.facade.state.getState();

    if (s.ui.konumKontrol && s.ui.currentStep === 2) {
      this.konumislmeleri(2);
    }
  }

  benimMesaj() {
    this.alertservice.message('Aktif Edilmek istenilen', 'Bilgi', {
      messageType: ToastrMessageType.Info,
      position: ToastrPosition.TopRight,
    });
  }

  exportToExcel() {
    const students = this.facade.getFilteredStudents();
    const slots = this.facade.state.getState().attendance.slots;

    const data = students.map((s) => {
      const row: any = {
        AdSoyad: s.adSoyad,
        OgrenciNo: s.studentId,
      };

      // 🔥 Her slot için kolon oluştur
      slots.forEach((slot: any, i: number) => {
        const a = s.attendance.find((x: any) => x.slotNumber === i + 1);

        row[`Saat${i + 1}`] = this.getStatusText(a);
      });

      return row;
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = {
      Sheets: { Yoklama: worksheet },
      SheetNames: ['Yoklama'],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    const blob = new Blob([excelBuffer], {
      type: 'application/octet-stream',
    });

    FileSaver.saveAs(blob, `yoklama_${new Date().getTime()}.xlsx`);
  }

  getStatusText(a: any): string {
    if (!a) return '-';
    if (a.katildiMi && !a.konumDisi) return 'Katıldı';
    if (a.katildiMi && a.konumDisi) return 'Konum Dışı';
    return 'Katılmadı';
  }
  getAttendanceSummary() {
    const state = this.facade.state.getState().attendance;
    const students = this.facade.getFilteredStudents();

    const isSaatBasi = state.yoklamaPeriyodu === 'saatbasi';

    const summary: any = {
      toplamOgrenci: students.length,
      toplamKatilan: 0,
      toplamKatilmayan: 0,
      saatler: [],
    };

    if (isSaatBasi) {
      const slots = state.slots || [];

      const slotCounts = slots.map((_: any, i: number) => ({
        saat: i + 1,
        katilan: 0,
        katilmayan: 0,
      }));

      students.forEach((s: any) => {
        let anyJoined = false;

        (s.attendance || []).forEach((a: any) => {
          const index = (a.slotNumber ?? 0) - 1;

          // 🔥 güvenlik check
          if (index < 0 || index >= slotCounts.length) return;

          if (a.katildiMi) {
            slotCounts[index].katilan++;
            anyJoined = true;
          } else {
            slotCounts[index].katilmayan++;
          }
        });

        anyJoined ? summary.toplamKatilan++ : summary.toplamKatilmayan++;
      });

      summary.saatler = slotCounts;
    } else {
      let katilan = 0;
      let katilmayan = 0;

      students.forEach((s: any) => {
        const a = s.attendance?.[0];

        if (a?.katildiMi) katilan++;
        else katilmayan++;
      });

      summary.toplamKatilan = katilan;
      summary.toplamKatilmayan = katilmayan;

      summary.saatler = [
        {
          saat: 'Tek Sefer',
          katilan,
          katilmayan,
        },
      ];
    }

    return summary;
  }
  konumislmeleri(step: number) {
    if (step && step !== 2) return;

    setTimeout(() => {
      if (!this.mapContainer) {
        console.log('Harita konteyneri yok!');
        return;
      }

      if (this.mapInitialized) return;

      const s = this.facade.state.getState();

      let lat: number | null = null;
      let lng: number | null = null;

      // 1️⃣ STATE (derslik)
      if (
        s.ui.latitude &&
        s.ui.longitude &&
        s.ui.latitude !== 0 &&
        s.ui.longitude !== 0
      ) {
        lat = s.ui.latitude;
        lng = s.ui.longitude;
      }

      // 2️⃣ BİNA
      else if (
        s.ui.binaLatitude &&
        s.ui.binaLongitude &&
        s.ui.binaLatitude !== 0 &&
        s.ui.binaLongitude !== 0
      ) {
        lat = s.ui.binaLatitude;
        lng = s.ui.binaLongitude;
      }

      // 3️⃣ KAMPÜS
      else if (
        s.ui.kampusLatitude &&
        s.ui.kampusLongitude &&
        s.ui.kampusLatitude !== 0 &&
        s.ui.kampusLongitude !== 0
      ) {
        lat = s.ui.kampusLatitude;
        lng = s.ui.kampusLongitude;
      }

      // ✅ Eğer bulunduysa direkt başlat
      if (lat !== null && lng !== null) {

        this.initMap(lat, lng);
        this.mapInitialized = true;
        return;
      }

      // 4️⃣ TARAYICI KONUMU
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = 39.93448; //position.coords.latitude;
            const lng = 32.82993; //position.coords.longitude;


            this.mapMessage =
              'Tarayacı konumu kullanıldı. Konumunuzun doğruluğunu kontrol edin ve gerekirse pin’i sürükleyerek dersliğin konumunu ayarlayın.';

            this.initMap(lat, lng);
            this.mapInitialized = true;
            return;
          },
          () => {
            this.initMap(39.93448, 32.82993);
            this.mapMessage =
              'Konum bilgisi alınamadı. Lütfen konum izinlerini kontrol edin. Sayfayı kapatıp tekrar açmayı deneyin.';
            this.mapInitialized = true;
            this.alertservice.message(this.mapMessage, 'Uyarı', {
              messageType: ToastrMessageType.Warning,
              position: ToastrPosition.TopFullWidth,
            });
            return;
          },
        );
      } else {

        this.mapMessage =
          'Tarayıcı konum desteği bulunamadı. Varsayılan konum gösteriliyor.';

        this.alertservice.message(this.mapMessage, 'Uyarı', {
          messageType: ToastrMessageType.Warning,
          position: ToastrPosition.TopFullWidth,
        });

        this.initMap(39.93448, 32.82993);
        this.mapInitialized = true;
        return;
      }
    }, 50);
  }
  ngOnInit(): void {
    this.state$ = this.facade.state$;

    this.facade.state$.subscribe((state) => {
      this.qrBase64 = state.ui.qrBase64;
      this.students = state.attendance.students;
    });
    this.facade.init();
  }

  initMap(lat: number, lng: number) {
    this.map = L.map(this.mapContainer.nativeElement).setView([lat, lng], 16);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap',
    }).addTo(this.map);

    this.setMarker(lat, lng, true);

    this.map.on('click', (e: any) => {
      this.facade.setBinaKonum(e.latlng.lat, e.latlng.lng);
      this.setMarker(e.latlng.lat, e.latlng.lng, true);
    });

    setTimeout(() => this.map.invalidateSize(), 300);
  }

  // Marker güncelle
  setMarker(lat: number, lng: number, draggable: boolean = false) {
    const customIcon = L.icon({
      iconUrl: 'assets/marker.png', // kendi pin resmin
      iconSize: [25, 41], // orijinal leaflet size
      iconAnchor: [12, 41], // pinin ucunu koordinata ortala
      popupAnchor: [1, -34],
      shadowSize: [41, 41],
    });

    if (this.marker) this.map.removeLayer(this.marker);

    // draggable parametresini buraya kullan
    this.marker = L.marker([lat, lng], { icon: customIcon, draggable }).addTo(
      this.map,
    );

    if (draggable) {
      this.marker.on('dragend', (e: any) => {
        const pos = e.target.getLatLng();
        this.facade.setBinaKonum(pos.lat, pos.lng);
      });
    }
  }
  onMapClick(lat: number, lng: number) {
    // 🔥 facade’a gönder
    this.facade.setLocation(lat, lng);
  }

  // ================= COURSE =================

  startLesson() {
    this.facade.startCourse();
  }

  endLesson() {
    this.facade.endLesson();
  }

  updateCourse() {
    this.facade.updateCourse();
  }

  // ================= SLOT =================

  startSlot() {
    this.facade.startSlot();
  }
  getStudentSlot(student: Student) {
    const s = this.facade.state.getState();

    const slotNumber =
      s.attendance.yoklamaPeriyodu === 'saatbasi'
        ? s.attendance.aktifSlotIndex + 1
        : 0;

    return student.attendance.find((a) => a.slotNumber === slotNumber);
  }
  nextSlot() {
    this.facade.nextSlot();
  }

  // ================= STUDENT =================

  markPresent(studentId: number, slot: number) {
    this.facade.markPresent(studentId, slot);
  }

  markAbsent(studentId: number, slot: number) {
    this.facade.markAbsent(studentId, slot);
  }

  // ================= OBS =================

  obsAktar() {
    this.facade.obsAktar();
  }

  // ================= GENERAL =================
  geri() {
    this.facade.geri();
  }
  reset() {
    this.facade.reset();
  }

  onSlotChange(index: number, value: boolean) {
    this.facade.setSlotActive(index, value);
  }

  maskName(name: string): string {
    if (!name) return '';

    return name
      .trim()
      .replace(/\s+/g, ' ')
      .split(' ')
      .map((part) => {
        if (part.length <= 2) {
          return part + '*';
        }
        return part.slice(0, 2) + '*'.repeat(part.length - 2);
      })
      .join(' ');
  }

  maskStudentNoCustom(studentNo: string): string {
    if (!studentNo) return '';

    const head = 2;
    const tail = 3;

    if (studentNo.length <= head + tail) {
      return '*'.repeat(studentNo.length);
    }

    const maskedLength = studentNo.length - (head + tail);

    return (
      studentNo.slice(0, head) +
      '*'.repeat(maskedLength) +
      studentNo.slice(-tail)
    );
  }

  maskSurname(surname: string): string {
    if (!surname) return '';

    if (surname.length <= 2) {
      return surname + '*';
    }

    return surname.slice(0, 2) + '*'.repeat(surname.length - 2);
  }
  formatKalanSure(kalanSure: number): string {
    const totalSec = kalanSure ?? 0;
    const mins = Math.floor(totalSec / 60);
    const secs = totalSec % 60;
    const two = (n: number) => n.toString().padStart(2, '0');
    return `${two(mins)}:${two(secs)}`;
  }
}
